export default __webpack_public_path__ + "static/CenturyExpanded-Italic-44826274536b8c1b05444624d1be01c7.woff";